import { v4 as uuidv4 } from 'uuid';
import { ConversationMessage } from '../types';

function createMessage(type: 'user' | 'assistant', content: string): ConversationMessage {
    return {
        messageId: uuidv4(),
        type,
        content,
        timestamp: new Date(),
    };
}

export function createUserMessage(content: string): ConversationMessage {
  return createMessage('user', content);
}

export function createAssistantMessage(content: string): ConversationMessage {
  return createMessage('assistant', content);
}
